import React, { Component } from 'react';
import { Button, Card, Col, message, Row, Table } from 'antd';
import { queryAgreeProject, queryProjectInfo, queryRefuseProject } from '@api/protect';
import DescriptionList from '@comm/DescriptionList';
import Description from '@comm/DescriptionList/Description';
import { BackBtn, goBack } from '@comm/BackBtn';

class PageOpen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      status: -1,
    };
  }

  componentDidMount() {
    this.id = this.props.params.id;
    this.model = this.props.params.model;
    this.loadData(this.id);
  }

  // 加载需公司回单卡信息数据
  loadData = id => {
    queryProjectInfo({ id }).then(res => {
      if (res.statusCode === 200) {
        this.setState(
          {
            data: res.data,
          },
          () => this.judge(this.id, this.model),
        );
      }
    });
  };

  columns = () => {
    return [
      {
        title: '姓名',
        dataIndex: 'memberName',
      },
      {
        title: '职位',
        dataIndex: 'position',
      },
      {
        title: '简介',
        dataIndex: 'memberIntro',
      },
    ];
  };

  handlerAgree = () => {
    queryAgreeProject({ id: this.id, model: this.model }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        goBack();
      } else {
        message.error(res.message);
      }
    });
  };

  handlerRefuse = () => {
    queryRefuseProject({ id: this.id, model: this.model }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        goBack();
      } else {
        message.error(res.message);
      }
    });
  };

  judge = (id, model) => {
    const { data } = this.state;
    data.requirement.forEach(item => {
      if (item.requirementId === Number(model)) {
        this.setState({
          status: item.requirementStatus,
        });
      }
    });
  };

  render() {
    const { data, status } = this.state;
    return (
      <Card>
        <div className="tableList">
          <Row style={{ paddingBottom: '20px' }}>
            <Col span={11}>
              <BackBtn />
              {status === 0 ? (
                <Button type="primary" style={{ marginRight: '10px' }} onClick={this.handlerAgree}>
                  同意
                </Button>
              ) : null}
              {status === 0 ? (
                <Button style={{ marginRight: '10px' }} onClick={this.handlerRefuse}>
                  拒绝
                </Button>
              ) : null}
            </Col>
          </Row>
        </div>

        <h2 style={{ color: '#2db7fd' }}>项目评分</h2>

        <DescriptionList col={2}>
          <Description term="综合评分">{data.avg}</Description>

          {data.grade
            ? data.grade.map(item => {
                return (
                  <Description term={item.name} key={item.name}>
                    {item.number}
                  </Description>
                );
              })
            : null}
        </DescriptionList>

        <h2 style={{ color: '#2db7fd' }}>基本信息</h2>

        <DescriptionList size="large" col={2}>
          <Description term="项目编号">{data.id}</Description>
          <Description term="所属公司">{data.companyName}</Description>
          <Description term="项目名称">{data.projectName}</Description>
          <Description term="项目标签">{data.tag}</Description>
          <Description term="项目分类">{data.tradeSort}</Description>
          <Description term="项目所在地">{data.businessPlace}</Description>
        </DescriptionList>

        <DescriptionList size="large" col={1}>
          <Description term="项目简介">{data.projectInfo}</Description>
        </DescriptionList>

        <h2 style={{ color: '#2db7fd' }}>联系信息</h2>

        <DescriptionList size="large" col={2}>
          <Description term="联系人">{data.linkman}</Description>
          <Description term="联系方式">{data.mobile}</Description>
        </DescriptionList>

        <h2 style={{ color: '#2db7fd' }}>团队信息</h2>

        <Table rowKey="id" columns={this.columns()} dataSource={data.team} pagination={false} />

        <h2 style={{ color: '#2db7fd' }}>项目附件</h2>

        <DescriptionList size="large" col={2}>
          <Description term="资料名称">
            {data.file
              ? data.file.map(item => {
                  return (
                    <a
                      href={`http://preview.oa.vcchina.com/upload?url=${item.url}`}
                      target="_blank"
                      rel="noreferrer"
                      key={item.fileId}
                    >
                      <span>{item.name}</span>
                    </a>
                  );
                })
              : null}
          </Description>
        </DescriptionList>
      </Card>
    );
  }
}

export default PageOpen;



// WEBPACK FOOTER //
// ./src/components/project/PageOpen.js